/**
 * Theme Logic (Scoped)
 */
/**
 * Theme Logic (Scoped)
 */
const getStoredTheme = () => localStorage.getItem('theme');
const setStoredTheme = theme => localStorage.setItem('theme', theme);

const setTheme = (theme) => {
    document.documentElement.setAttribute('data-bs-theme', theme);
    setStoredTheme(theme);

    // Find ALL icons with this class
    const themeIcons = document.querySelectorAll('.theme-icon-set');

    themeIcons.forEach(icon => {
        if (theme === 'dark') {
            icon.classList.replace('bi-sun-fill', 'bi-moon-stars-fill');
        } else {
            icon.classList.replace('bi-moon-stars-fill', 'bi-sun-fill');
        }
    });
};

/**
 * Initialize Theme
 * Priority: 1. LocalStorage -> 2. Default to 'light'
 */
const storedTheme = getStoredTheme();
// We removed the matchMedia check to ensure 'light' is the fallback
setTheme(storedTheme || 'light');

/**
 * Global Event Listener (Delegated)
 * This works outside DOMContentLoaded
 */
document.addEventListener('click', (e) => {
    // Listen for the class instead of the ID
    const themeBtn = e.target.closest('.theme-toggle-btn');

    if (themeBtn) {
        const currentTheme = document.documentElement.getAttribute('data-bs-theme');
        const nextTheme = currentTheme === 'dark' ? 'light' : 'dark';
        setTheme(nextTheme);
    }
});
